import Shell from "@/pages/Shell";
import { Seo } from "@/components/Seo";
import { Community } from "@/components/Community";

export default function CommunityPage() {
  return (
    <Shell>
      <Seo
        title="Community Work & Impact — Charles McKuhn"
        description="Youth mentorship, local outreach, and revival gatherings led by Charles McKuhn. Service that shows up and stays — building communities one relationship at a time."
        path="/community"
      />
      <h1 className="sr-only">Community Work & Impact — Charles McKuhn</h1>
      <Community />
    </Shell>
  );
}
